/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react'
import { CPIDataGrid } from './index'
import { getLocalStorage, removeLocalStorage } from '../../utils/localStorage'
import { ReactComponent as Loader } from '../../assets/images/loadin-tree-point.svg'
import {
  handleOrder,
  initOrderColumn,
  savedConfig,
} from '../../utils/preference_table'

function CPIDataGridFiche(props) {
  const [isExistConf, setIsExistConf] = useState(false)
  const [orderColumn, setOrderColumn] = useState(props.columns || [])
  const [loaderCreate, setLoaderCreate] = useState(false)
  const path = props?.prefKey

  const updateConfig = async () => {
    setLoaderCreate(true)
    savedConfig(() => {
      setLoaderCreate(false)
      removeLocalStorage('configColumn')
      setIsExistConf(false)
    })
  }

  const handleOrderColumn = (column) => {
    if (!path) return
    handleOrder(column, path, props.tableName, setOrderColumn, setIsExistConf)
  }

  // Order column
  useEffect(() => {
    initOrderColumn(props.columns, path, props.tableName, setOrderColumn)
  }, [props.columns])

  useEffect(() => {
    const defaultOrderMenu = getLocalStorage('configColumn')
    const parsedData = defaultOrderMenu ? JSON.parse(defaultOrderMenu) : null
    if (parsedData) {
      setIsExistConf(true)
    }
  }, [])

  return (
    <div style={{ position: 'relative', height: '100%' }}>
      <CPIDataGrid
        pagination=""
        export={false}
        columnOrder={orderColumn}
        onColumnOrderChange={(column) => {
          if (path) {
            handleOrderColumn(column)
            return
          }
          setOrderColumn(column)
        }}
        enableColumnFilterContextMenu={!!props?.isShowMenu}
        showColumnMenuTool={!!props?.isShowMenu}
        title={props.title}
        {...props}
      />
      <div
        style={{
          position: 'absolute',
          right: !props.export ? 15 : 55,
          bottom: loaderCreate ? 3 : -4,
          display: path && isExistConf ? '' : 'none',
          cursor: 'pointer',
        }}
      >
        {loaderCreate ? (
          <Loader />
        ) : (
          <span
            className="pcoded-micon"
            style={{ paddingRight: '5px', fontSize: '24px' }}
            onClick={() => updateConfig()}
          >
            <i
              className="icon feather icon-save"
              style={{ color: '#01a9ac', cursor: 'pointer' }}
              role="button"
              aria-label="Edit"
              tabIndex="0"
            />
          </span>
        )}
      </div>
    </div>
  )
}
export default CPIDataGridFiche
